import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Translate } from 'react-localize-redux';
import css from './page.css';
import { Button, Spinner } from '../components/widgets';
import ReferralsIcon from '../resources/svg/referrals_icon.svg';
import AgencyEmptyState from '../components/partials/AgencyEmptyState';
import PartnerEmptyState from '../components/partials/PartnerEmptyState';
import { getPage } from './selectors';
import { useOrganizations } from '../services/organizationsHooks';
import { SHOW_ACCOUNT_SELECT_MODAL_EVENT } from '../topbar/consts';

function PartnersLandingPage() {
    const { partnerName, accountTypeReady, isAgency, agencyName, agencyId } = useSelector(getPage);
    const { organizations, loaded, loadFailed, load } = useOrganizations();

    useEffect(() => {
        if (accountTypeReady) {
            load();
        }
    }, [accountTypeReady, load]);

    const openDialog = () => window.dispatchEvent(new Event(SHOW_ACCOUNT_SELECT_MODAL_EVENT));

    const showSpinner = !accountTypeReady || (!loaded && !loadFailed);
    // A failed load is not "no accounts yet": keep the button so the dialog can report the failure.
    const noAccounts = loaded && organizations.length === 0;
    const showAgencyEmptyState = accountTypeReady && isAgency && noAccounts;
    const showPartnerEmptyState = accountTypeReady && !isAgency && noAccounts;

    return (
        <div className={css.container}>
            <div className={css.header}>
                <Translate id="STATIC.PAGES.PARTNERS_PORTAL.LANDING_PAGE_HEADER" data={{ partnerName }} />
            </div>
            {showSpinner ? (
                <Spinner show />
            ) : showAgencyEmptyState ? (
                <AgencyEmptyState agencyName={agencyName} agencyId={agencyId} />
            ) : showPartnerEmptyState ? (
                <PartnerEmptyState />
            ) : (
                <>
                    <div className={css.subHeader}>
                        <Translate id="STATIC.PAGES.PARTNERS_PORTAL.LANDING_PAGE_SUB_HEADER" />
                    </div>
                    <ReferralsIcon />
                    <Button className={css.button} level="important" onClick={openDialog}>
                        <Translate id="STATIC.PAGES.PARTNERS_PORTAL.LANDING_PAGE_BUTTON" />
                    </Button>
                </>
            )}
        </div>
    );
}

export default PartnersLandingPage;
